import {
    Directive,
    Inject,
    Input,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';
import {
    EMPLOYEE_AUTH_SERVICE_IMPL,
    IEmployeeAuthService,
} from 'pm-src/services/employee-auth/i-employee-auth.service';
import { Subject } from 'rxjs';
import {
    AUTH_SERVICE_IMPL,
    IAuthenticationService,
    Policy,
    User,
    UserRole,
} from 'shared';
import { Employee } from '../models/employee';
import { EmployeeRole } from '../types/employee-role';

@Directive({
    selector: '[appEmpCan]',
})
export class EmployeeCanDirective implements OnInit, OnDestroy {
    @Input() appEmpCan: Policy;

    stop$ = new Subject();
    isVisible = false;

    constructor(
        private viewContainerRef: ViewContainerRef,
        private templateRef: TemplateRef<any>,
        @Inject(EMPLOYEE_AUTH_SERVICE_IMPL)
        private _employeeAuthService: IEmployeeAuthService,
        @Inject(AUTH_SERVICE_IMPL) private _authService: IAuthenticationService
    ) {}

    ngOnInit(): void {
        this._employeeAuthService.employee$.subscribe((employee) => {
            if (employee) {
                this.checkEmployeeCan(employee);
            } else {
                this._authService.applicationUser.subscribe((user) => {
                    if (user) {
                        this.checkUserCan(user);
                    }
                });
            }
        });
    }

    private checkEmployeeCan(employee: Employee): void {
        const employeeRoles = employee.roles.map((role) => role.toLowerCase());
        const policyRole = this._employeeAuthService
            .getPolicyRoles()
            .find((x) => x.policy === this.appEmpCan);

        let policyRoles: string[] = [];

        if (policyRole !== undefined) {
            policyRoles = policyRole.roles.map((r) => EmployeeRole[r].toLowerCase());
        }

        if (
            policyRole === undefined ||
            employeeRoles.every((role) => !policyRoles.includes(role))
        ) {
            this.isVisible = false;
            this.viewContainerRef.clear();
        } else if (!this.isVisible) {
            this.isVisible = true;
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
    }

    private checkUserCan(user: User): void {
        const userRoles = user.roles.map((role) => role.toLowerCase());
        const policyRole = this._authService
            .getPolicyRoles()
            .find((x) => x.policy === this.appEmpCan);

        let policyRoles: string[] = [];

        if (policyRole !== undefined) {
            policyRoles = policyRole.roles.map((r) => UserRole[r].toLowerCase());
        }

        if (
            policyRole === undefined ||
            userRoles.every((role) => !policyRoles.includes(role))
        ) {
            this.isVisible = false;
            this.viewContainerRef.clear();
        } else if (!this.isVisible) {
            this.isVisible = true;
            this.viewContainerRef.createEmbeddedView(this.templateRef);
        }
    }

    ngOnDestroy(): void {
        this.stop$.next(true);
    }
}
